import { Button, Container, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import EirInformation from '../eir-information/EirInformation';
import styles from './style';

const { publicRuntimeConfig } = getConfig();

const EirEmptyCart = () => {
  const theme = useTheme();
  const router = useRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth='md'>
      <Grid container sx={{ p: 3, mt: 5, mb: 5 }}>
        <Grid item xs={12} sm={12} sx={styles(theme).cartIcon}>
          <ShoppingCartOutlinedIcon
            sx={{ fontSize: '6.5rem', color: theme.palette.primary.buttonColor }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <EirInformation
            title='Looks like your cart is empty'
            description='Why not take a look at some of our great offers?'
            textAlign='center'
          />
        </Grid>
        <Grid item xs={12} sm={12} sx={styles(theme).buttonContainer}>
          <Button
            variant='buttonMedium'
            sx={styles(theme).emptyCartButton}
            onClick={() => router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband`)}
            aria-label='View offers'
          >
            View offers
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
export default EirEmptyCart;
